import DomComponent from 'App/lib/domComponent';
import {
    validateEmail,
    validatePhone
} from 'App/lib/util';

export default class InputComponent extends DomComponent {
    static selector = '[data-js-input]';
    _value;

    ignoredKeys = [13, 16];

    set value(v) {
        this.input.value = v;
        this.emitEvent('input:change', this.el, {
            value: v,
            name: this.input.name
        });
        this.emitEvent('input', this.input);
    }

    get value() {
        return this.input.value;
    }

    constructor(el, form) {
        // return false
        super(el);

        this.input = this.el.querySelector('input');

        if (!this.input) {
            this.input = this.el.querySelector('textarea');
        }

        if (form) {
            this.form = form;
        }


        this.label = this.el.querySelector('label');
        this.errorMessage = this.createErrorMessage();

        const name = this.input ? this.input.getAttribute('name') : Math.random();
        this.id = this.el.dataset.input ? this.el.dataset.input : name;

        if (this.input) {
            this.input.addEventListener('keydown', this.keyDownHandler.bind(this));
            this.input.addEventListener('focus', this.focusHandler.bind(this));
            this.input.addEventListener('blur', this.blurHandler.bind(this));
        }

        if (this.input.value) {
            this.dirty();
        }

        setTimeout(() => {
            this.loaded();
        })
    }

    keyDownHandler(e) {
        if (this.ignoredKeys.indexOf(e.keyCode) === -1) {
            this.value = this.input.value;
            this.dirty();

            setTimeout(() => {
                this.validate();
            })
        }

    }

    createErrorMessage() {
        const div = document.createElement('div');
        div.classList.add('form__error');
        return div;
    }

    setValue(v) {
        this.value = v;
        if (v === null) {
            this.clean()
        } else {
            this.dirty();
        }
    }

    select() {
        this.input.select();
    }

    focusHandler(e) {
        this.focus();
        this.dirty();
    }

    blurHandler(e) {
        this.blur();

        if (!this.value) {
            this.clean()
        }
    }

    setError(valid, message) {
        if (valid) {
            this.el.classList.remove('error');
            setTimeout(() => {
                this.errorMessage.remove();
            });
        } else {
            this.errorMessage.innerText = message;
            this.el.appendChild(this.errorMessage);
            this.el.classList.add('error');
        }

        return valid;
    }

    validate() {
        let valid = true;
        let message = "";

        if (typeof this.el.dataset.required !== 'undefined') {
            if (this.value === null || this.value === '') {
                valid = false;
                message = 'This field is required.';

                return this.setError(valid, message);
            }
        }

        if (this.input && this.input.value === "") {
            return this.setError(valid);
        }

        if (typeof this.el.dataset.email !== 'undefined' || this.input.name === 'email') {
            const isValidEmail = validateEmail(this.value);
            if (!isValidEmail) {
                valid = false;
                message = `"${this.input.value}" is not a valid email`;
            }
        }

        if ((this.el.dataset.regex === 'phone' || this.input.name === 'phone')) {
            const isValidEmail = validatePhone(this.value);
            if (!isValidEmail) {
                valid = false;
                message = `"${this.input.value}" is not a valid phone number`;
            }
        }

        if (typeof this.el.dataset.equalTo !== 'undefined' && this.form) {
            const equalToField = this.form.getField(this.el.dataset.equalTo);

            if (equalToField.value !== null && equalToField.value !== "") {
                if (this.value !== equalToField.value) {
                    valid = false;
                    message = 'These fields do not match';
                    equalToField.setError(false, 'These fields do not match');
                } else {
                    equalToField.setError(true);
                }

            }
        }

        this.setError(valid, message);

        return valid;
    }

    focus() {
        this.el.classList.add('focus');
    }
    blur() {
        this.el.classList.remove('focus');
        this.validate();
    }
    dirty() {
        this.el.classList.add('dirty');
    }
    clean() {
        this.el.classList.remove('dirty');
    }

    emitEvent(name, element, data) {
        let event;
        if (typeof window.CustomEvent === 'function') {

            // Typical implementation for CustomEvent.
            event = new CustomEvent(name, {
                bubbles: true,
                detail: data
            });

        } else {

            // IE11 implementation for CustomEvent.
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(name, true, false, data);

        }
        element.dispatchEvent(event);
    }
}
